import classNames from "classnames";
import { parseISO } from "date-fns";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";
import { formatDate } from "~/utils/format";
import styles from "./HorizontalCard.module.scss";

interface HorizontalCardProps {
  className?: string;
  name: string;
  url?: string;
  thumbnail?: string;
  date?: string;
}

const HorizontalCard: FC<HorizontalCardProps> = (props) => {
  const { className, name, url, thumbnail, date } = props;
  const { i18n } = useTranslation();

  if (!url) {
    return (
      <div className={classNames(styles.item, className)}>
        <div className={styles.thumbnail}>
          <Image
            src={thumbnail || "/images/card_default.png"}
            alt={name}
            fill
          />
        </div>

        <div className="flex flex-col gap-2">
          <div className={classNames(styles.title, "line-clamp-3")}>{name}</div>
          {date && (
            <p className={styles.date}>
              {formatDate(parseISO(date), "MMM d, yyyy", i18n.language)}
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={classNames(styles.item, className)}>
      <Link href={url} className={styles.thumbnail}>
        <Image src={thumbnail || "/images/card_default.png"} alt={name} fill />
      </Link>

      <div className="flex flex-col gap-2">
        <Link href={url} className={classNames(styles.title, "line-clamp-3")}>
          {name}
        </Link>
        {date && (
          <p className={styles.date}>
            {formatDate(parseISO(date), "MMM d, yyyy", i18n.language)}
          </p>
        )}
      </div>
    </div>
  );
};

export default HorizontalCard;
